/**
 * Minimal logging utility with configurable log levels
 * Provides structured logging for the SDK
 */
const LOG_LEVEL_PRIORITY = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    silent: 4,
};
/**
 * Creates a logger instance with the specified log level
 * @param initialLevel - The initial log level (default: 'info')
 * @param prefix - Optional prefix for log messages (default: '[browser-first-ai]')
 */
export function createLogger(initialLevel = 'info', prefix = '[browser-first-ai]') {
    let currentLevel = initialLevel;
    const shouldLog = (level) => {
        return LOG_LEVEL_PRIORITY[level] >= LOG_LEVEL_PRIORITY[currentLevel];
    };
    const formatMessage = (level, message) => {
        const timestamp = new Date().toISOString();
        return `${timestamp} ${prefix} [${level.toUpperCase()}] ${message}`;
    };
    const log = (level, consoleMethod, message, data) => {
        if (!shouldLog(level))
            return;
        const formattedMessage = formatMessage(level, message);
        if (data !== undefined) {
            console[consoleMethod](formattedMessage, data);
        }
        else {
            console[consoleMethod](formattedMessage);
        }
    };
    return {
        debug(message, data) {
            log('debug', 'log', message, data);
        },
        info(message, data) {
            log('info', 'info', message, data);
        },
        warn(message, data) {
            log('warn', 'warn', message, data);
        },
        error(message, data) {
            log('error', 'error', message, data);
        },
        setLevel(level) {
            currentLevel = level;
        },
    };
}
//# sourceMappingURL=logger.js.map